import { requester } from '../utils';

export const fetchAllMessages = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/channel-message?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const fetchAllMessageReceivers = (id, query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/channel-message/users/${id}?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllDiscountCodes = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/discount-code/activated`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const sendMessage = ({
  messageTitle,
  messageBody,
  isPublished,
  expiration,
  specialUserIds,
  receiverType,
  minOrderInReservationValue,
  minSuccessfulReservationValue,
  discountCode
}) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/channel-message`,
        method: 'POST',
        data: {
          title: messageTitle,
          specialUserIds,
          receiverType,
          minOrderInReservationValue,
          minSuccessfulReservationValue,
          body: messageBody,
          isPublished,
          discountCodeId: discountCode,
          expiredAtJalaali: expiration
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchMessageById = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/channel-message/panel/find/${id}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
